import { render, staticRenderFns } from "./Subempreitadas.vue?vue&type=template&id=a3f83800"
import script from "./Subempreitadas.vue?vue&type=script&lang=js"
export * from "./Subempreitadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports